export function windowed_average(array: number[], n: number, w: number): number {
    if (n - w < 0) return NaN;
    return array.slice(n - w, n + 1).reduce((a, b) => a + b) / (w + 1);
}
